"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduceRight(function (prevFn, nextFn) {
    return function () {
      return nextFn(prevFn.apply(void 0, arguments));
    };
  }, function (value) {
    return value;
  });
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9jb21wb3NlLnRzIl0sIm5hbWVzIjpbImZ1bmNzIiwicmVkdWNlUmlnaHQiLCJwcmV2Rm4iLCJuZXh0Rm4iLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUFlO0FBQUEsb0NBQUlBLEtBQUo7QUFBSUEsSUFBQUEsS0FBSjtBQUFBOztBQUFBLFNBQ2JBLEtBQUssQ0FBQ0MsV0FBTixDQUFrQixVQUFDQyxNQUFELEVBQVNDLE1BQVQ7QUFBQSxXQUNoQjtBQUFBLGFBQWFBLE1BQU0sQ0FBQ0QsTUFBTSxNQUFOLG1CQUFELENBQW5CO0FBQUEsS0FEZ0I7QUFBQSxHQUFsQixFQUVFLFVBQUFFLEtBQUs7QUFBQSxXQUFJQSxLQUFKO0FBQUEsR0FGUCxDQURhO0FBQUEsQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0ICguLi5mdW5jcykgPT5cbiAgZnVuY3MucmVkdWNlUmlnaHQoKHByZXZGbiwgbmV4dEZuKSA9PlxuICAgICguLi5hcmdzKSA9PiBuZXh0Rm4ocHJldkZuKC4uLmFyZ3MpKSxcbiAgICB2YWx1ZSA9PiB2YWx1ZVxuICApOyJdfQ==